import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router';

import { url } from 'helpers';
import { useAuth } from 'hooks';
import { RouteProps } from 'types/routes';

const PublicRoute: FC<RouteProps> = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.authenticated) {
    const returnUrl = location.state?.returnUrl;

    return <Navigate to={returnUrl ?? url.toDashboard()} />;
  }

  return children;
};

export default PublicRoute;
